import {
  adapter,
  getScriptTag,
  type TrackingProps,
} from '@seek/tealium-adapter';

import type { Environment } from '#src/hooks/environment.tsx';

export interface AnalyticsClient {
  link: (eventName: string | string[], props?: TrackingProps) => void;
  view: (eventName: string | string[], props?: TrackingProps) => void;
}

export const getTealiumSrcUrl = (environment: Environment) => {
  const tealiumEnvironment = {
    localProd: 'dev',
    localDev: 'dev',
    dev: 'qa',
    prod: 'prod',
  }[environment];

  const scriptTag = getScriptTag({
    account: 'seek',
    profile: 'hirer',
    environment: tealiumEnvironment,
  });

  const parser = new DOMParser();
  const doc = parser.parseFromString(scriptTag, 'text/html');
  const scriptElement = doc.querySelector('script');

  return scriptElement ? scriptElement.src : null;
};

export const createAnalyticsProvider = (
  trackingEnabled: boolean,
): AnalyticsClient => {
  const tealium = adapter();

  return new Proxy<AnalyticsClient>(tealium as AnalyticsClient, {
    get(target, prop: keyof AnalyticsClient) {
      if (typeof target[prop] !== 'function') {
        return Reflect.get(target, prop);
      }
      return (...fnArgs: unknown[]) => {
        if (!trackingEnabled) {
          // Uncomment to debug tracking locally
          // // eslint-disable-next-line no-console
          // console.log(
          //   'TRACKING DISABLED for this environment. Event details:',
          //   {
          //     prop,
          //     ...fnArgs,
          //   },
          // );
          return null;
        }
        return Reflect.apply(target[prop], target, fnArgs);
      };
    },
  });
};
